import { CheckboxEditor } from '@approvalmax/ui';
import { Divider, Flex } from '@approvalmax/ui/src/components';
import { FC, memo, useCallback } from 'react';

import { Avatar, Name, PaddedGrid } from './UserItem.styles';
import { UserItemProps } from './UserItem.types';

const UserItem: FC<UserItemProps> = memo((props) => {
    const { user, setCheckedUserIds, checkedUserIds, isLast } = props;

    const toggleUserSelection = useCallback(() => {
        setCheckedUserIds((checkedUserIds) => {
            const wasChecked = checkedUserIds.includes(user.id);

            if (wasChecked) {
                return checkedUserIds.filter((userId) => userId !== user.id);
            } else {
                return [...checkedUserIds, user.id];
            }
        });
    }, [setCheckedUserIds, user.id]);

    return (
        <>
            <PaddedGrid alignItems='center' key={user.id} spacing='0 12' wrap={false}>
                <CheckboxEditor value={checkedUserIds.includes(user.id)} onChange={toggleUserSelection} />

                <div onClick={toggleUserSelection}>
                    <Flex alignItems='center' width='100%' wrap={false}>
                        <Avatar size={30} user={user} />

                        <Name>{user.displayName}</Name>
                    </Flex>
                </div>
            </PaddedGrid>

            {!isLast && <Divider />}
        </>
    );
});

export default UserItem;
